import { Grid, Paper } from '@material-ui/core';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import { enTheme } from 'interfaces/theme';
import React, { PureComponent } from 'react';
import { productNewService } from 'services/productNewService';

import { SvgIcon } from '../SvgIcon';

interface IProps {
  classes?: any;
  selectedTheme?: enTheme;
  changeType: Function;
}

interface IState {
  selectedProduct: IProductNew;
  selected?: enTheme;
}

@WithStyles(theme => ({
  container: {
    cursor: 'pointer',
    padding: 20,
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    alignItems: 'center'
  },
  card: {
    maxWidth: 140,
    width: '100%',
    marginBottom: 18
  },
  title: {
    textAlign: 'center',
    margin: '16px 0 0 0'
  },
  containerSvg: {
    width: 80,
    height: 80,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      width: '100%'
    }
  },
  template: {
    border: '1px solid #D9D9D9'
  },
  selected: {
    border: `1px solid ${theme.variables.colors['success']}`
  }
}))
export default class SelectTheme extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { selected: props.selectedTheme, selectedProduct: null };
  }

  changeSelected = (selected: enTheme) => {
    this.setState({ selected });
    this.props.changeType(selected);
  };

  componentDidMount() {
    productNewService.getSelectedProduct().subscribe(selectedProduct => this.setState({ selectedProduct }));
  }

  render() {
    const { classes } = this.props;
    const { selectedProduct } = this.state;
    if (!selectedProduct) {
      return null;
    }

    return (
      <Grid container justify="center" spacing={8}>
        <Grid className={classes.card} item sm={4}>
          <Paper
            elevation={1}
            onClick={this.changeSelected.bind(this, enTheme.PADRAO)}
            className={`${this.state.selected == enTheme.PADRAO ? classes.selected : ''} ${classes.template}`}
          >
            <div className={classes.container}>
              <div className={classes.containerSvg}>
                <SvgIcon name={'templateRetro'} />
              </div>
              <p className={classes.title}>Padrão</p>
            </div>
          </Paper>
        </Grid>
        {selectedProduct.type !== 4 && (
          <Grid className={classes.card} item sm={4}>
            <Paper
              elevation={1}
              onClick={this.changeSelected.bind(this, enTheme.HOTSITE)}
              className={`${this.state.selected == enTheme.HOTSITE ? classes.selected : ''} ${classes.template}`}
            >
              <div className={classes.container}>
                <div className={classes.containerSvg}>
                  <SvgIcon name={'templateHotsite'} />
                </div>
                <p className={classes.title}>Hotsite</p>
              </div>
            </Paper>
          </Grid>
        )}
        {selectedProduct.type !== 4 && (
          <Grid className={classes.card} item sm={4}>
            <Paper
              elevation={1}
              onClick={this.changeSelected.bind(this, enTheme.WIDGET)}
              className={`${this.state.selected == enTheme.WIDGET ? classes.selected : ''} ${classes.template}`}
            >
              <div className={classes.container}>
                <div className={classes.containerSvg}>
                  <SvgIcon name={'templateWidget'} />
                </div>
                <p className={classes.title}>Widget</p>
              </div>
            </Paper>
          </Grid>
        )}
      </Grid>
    );
  }
}
